import { put, takeLatest } from 'redux-saga/effects';
import staffActionTypes from '../types';
import { Notify } from '@flexisaf/flexibull2';
import { editStaffFailure, editStaffSuccess } from '../actions';
import httpClient from '../../../utils/http-client';
import { handleError } from '../../../utils/utils';

export function* requestProfileEdit({ payload }) {
  try {
    const response = yield httpClient.post('/staff/profile-edit', payload);
    yield put(editStaffSuccess(response.data));
    Notify('Request submitted successfully', { position: 'top-right' });
  } catch (error) {
    yield put(editStaffFailure(error?.message));
    const err = handleError(error);
  }
}

export function* onRequestProfileEdit() {
  yield takeLatest(staffActionTypes.CREATE_STAFF_PROFILE_EDIT_REQUEST, requestProfileEdit);
}
